export default "__VITE_ASSET__ClyP8IOP__"